export default {
  deviceMonitor_00001: 'Occupying',
  deviceMonitor_00002: 'Charger is disabled',
  deviceMonitor_00003: 'Charger is offline',
  deviceMonitor_00005: 'Change into available',
  deviceMonitor_00006: 'Start charging',
  deviceMonitor_00008: 'Appointment in progress',
  deviceMonitor_00009: 'No fault codes',
  deviceMonitor_00010: "Charger rebooted successfully",
  deviceMonitor_00011: "Remote reboot",
  deviceMonitor_00012: "Charger reboot failed",
  deviceMonitor_00013: "Charger Management",
  deviceMonitor_00014: "Current fault",
  deviceMonitor_00015: "Troubleshooting",
  deviceMonitor_00016: "Enter charger name or SN",
  deviceMonitor_00017: "Select or enter station",
  deviceMonitor_00018: "All",
  deviceMonitor_00019: "Charger type：",
  deviceMonitor_00020: "DC",
  deviceMonitor_00021: "AC",
  deviceMonitor_00022: "Gateway",
  deviceMonitor_00023: "Fault",
  deviceMonitor_00024: "Offline",
  deviceMonitor_00025: "Available",
  deviceMonitor_00026: "View plug in only",
  deviceMonitor_00027: "Charging",
  deviceMonitor_00028: "View plug out only",
  deviceMonitor_00029: "Offline",
  deviceMonitor_00030: "Disabled",
  deviceMonitor_00031: "SN：",
  deviceMonitor_00032: "Manufacturer-model：",
  deviceMonitor_00033: "Station：",
  deviceMonitor_00034: "Reboot charger",
  deviceMonitor_00035: "Details",
  deviceMonitor_00036: "Connector：",
  deviceMonitor_00037: "Offline",
  deviceMonitor_00038: "Disabled",
  deviceMonitor_00039: "Fault",
  deviceMonitor_00040: "Occupied",
  deviceMonitor_00041: "Charging",
  deviceMonitor_00042: "Available",
  deviceMonitor_00043: "Pending EV move",
  deviceMonitor_00044: "reserved",
  deviceMonitor_00045: "Connected",
  deviceMonitor_00046: "Connected",
  deviceMonitor_00047: "Transactions",
  deviceMonitor_00048: "Restart charging point",
  deviceMonitor_00049: "Device reboot command has been sent, the reboot process will take approximately 5 minutes. Please stay on this page and do not refresh the page",
  deviceMonitor_00050: "Prompt message",
  deviceMonitor_00051: "Confirm",
  deviceMonitor_00052: "Charger Management",
  deviceMonitor_00053: "Current fault",
  deviceMonitor_00054: "Plug in",
  deviceMonitor_00055: "Charging session end",
  deviceMonitor_00056: "Not enabled",
  deviceMonitor_00057: "Normal",
  deviceMonitor_00058: "Fault",
  deviceMonitor_00059: "Locked",
  deviceMonitor_00060: "Standby",
  deviceMonitor_00061: "Unknown",
  deviceMonitor_00062: "Charger Status：",
  deviceMonitor_00063: "Fault",
  deviceMonitor_00064: "View unreturn only",
  deviceMonitor_00065: "Homed",
  deviceMonitor_00066: "Not homed",
  deviceMonitor_00067: "Abnormal",
  deviceMonitor_00068: "energy storage cabinet",
  deviceMonitor_00085: "Dual Platform",
  deviceMonitor_00086: "Add Charger",
}